import React from 'react'
import { com } from '@eidu/web'
import { CircularProgress } from '@mui/material'
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import EntityPathPermissionContent from './EntityPathPermissionContent'
import EntityPath = com.eidu.sharedlib.entity.path.EntityPath
import EntityType = com.eidu.sharedlib.entity.type.EntityType

export type PathPermissionProps = {
  fromEntityTypeId: EntityTypeId | undefined
  preselectedPath?: EntityPath
  entityTypes: readonly EntityType[]
  onChange: (path: EntityPath | undefined) => void
  lockedToTypeId?: EntityTypeId
}

const PathPermission: React.FC<PathPermissionProps> = ({
  fromEntityTypeId,
  preselectedPath,
  entityTypes,
  onChange,
  lockedToTypeId,
}) => {
  if (entityTypes.length === 0) {
    return <CircularProgress />
  } else {
    return (
      <EntityPathPermissionContent
        fromEntityTypeId={fromEntityTypeId}
        preselectedPath={preselectedPath}
        entityTypes={entityTypes}
        onChange={onChange}
        lockedToTypeId={lockedToTypeId}
      />
    )
  }
}

export default PathPermission
